import {Axios} from '@galilee/sdk-core';
import {getAuthorizationJwtHeader} from '@common/helpers/api/apiHelper';
import documentTypes from '@common/constants/documents/documentTypes';
import {StsCredentials} from '@common/types/aws/aws.types';
import {Filters} from '@common/types/components/datatable.types';
import {ActionsResponse, ElasticResponse} from '@common/types/documents/apiResponses.types';
import {ResolveContexts, ResolveContextsParams} from '@common/types/stores/productSheetStore.types';
import {CONTENT_TYPE_JSON} from '@common/constants/api/apiConstants';
import {ClaimsFormValue} from '@common/types/forms/productForms.types';

export const apiGetProducts = async (baseUrl: string, filters: Filters, credentials: StsCredentials, scopedJwt: string): Promise<ElasticResponse> => {
  return new Axios<ElasticResponse, ElasticResponse>()
    .withUrl(baseUrl)
    .withAwsCredentials(credentials)
    .withHeaders(getAuthorizationJwtHeader(scopedJwt))
    .withPathsUrl('documents')
    .withParamsUrl({...filters, typeId: documentTypes.PRODUCT})
    .get();
};

export const apiGetProductDeps = async (baseUrl: string, filters: Filters, scopedJwt: string): Promise<ElasticResponse> => {
  return new Axios<ElasticResponse, ElasticResponse>()
    .withUrl(baseUrl)
    .withHeaders({...getAuthorizationJwtHeader(scopedJwt), CacheSearchDependenciesBreaker: 'cache'})
    .withPathsUrl('documents', 'search-deps')
    .withParamsUrl({...filters, groupedByField: 'productId'})
    .get();
};

export const apiPutInDraft = async (baseUrl: string, uuid: string, credentials: StsCredentials, scopedJwt: string): Promise<ActionsResponse> => {
  return new Axios<object, ActionsResponse>()
    .withUrl(baseUrl)
    .withAwsCredentials(credentials)
    .withHeaders({...getAuthorizationJwtHeader(scopedJwt)})
    .withPathsUrl('documents', uuid, 'actions', 'put-in-draft')
    .post();
};

export const apiResolveContextsUuid = async (baseUrl: string, data: ResolveContextsParams, credentials: StsCredentials, scopedJwt: string): Promise<ResolveContexts> => {
  return new Axios<object, ResolveContexts>()
    .withUrl(baseUrl)
    .withAwsCredentials(credentials)
    .withHeaders({...getAuthorizationJwtHeader(scopedJwt), 'Content-Type': CONTENT_TYPE_JSON})
    .withPathsUrl('documents', 'static:product-sheet', 'actions', 'resolve-contexts')
    .post(data);
};

export const apiEditClaimUsage = async (baseUrl: string, uuid: string, data: object, credentials: StsCredentials, scopedJwt: string, action: string): Promise<ActionsResponse> => {
  return new Axios<object, ActionsResponse>()
    .withUrl(baseUrl)
    .withAwsCredentials(credentials)
    .withHeaders({...getAuthorizationJwtHeader(scopedJwt), 'Content-Type': CONTENT_TYPE_JSON})
    .withPathsUrl('documents', uuid, 'actions', action)
    .post(data);
};

export const apiReplaceClaim = async (baseUrl: string, uuid: string, data: object, credentials: StsCredentials, scopedJwt: string): Promise<{transactionId: string}> => {
  return new Axios<object, {transactionId: string}>()
    .withUrl(baseUrl)
    .withAwsCredentials(credentials)
    .withHeaders({...getAuthorizationJwtHeader(scopedJwt), 'Content-Type': CONTENT_TYPE_JSON})
    .withPathsUrl('documents', uuid, 'actions', 'replace-claim')
    .post(data);
};

export const apiGenerateClaims = async (baseUrl: string, uuid: string, data: ClaimsFormValue, credentials: StsCredentials, scopedJwt: string): Promise<{transactionId: string}> => {
  return new Axios<object, {transactionId: string}>()
    .withUrl(baseUrl)
    .withAwsCredentials(credentials)
    .withHeaders({...getAuthorizationJwtHeader(scopedJwt), 'Content-Type': CONTENT_TYPE_JSON})
    .withPathsUrl('documents', uuid, 'actions', 'generate-claims')
    .post(data);
};
